import React, { createContext, useState, useContext } from 'react';

// Create the language context
const LanguageContext = createContext();

// Language provider component
export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('en'); // Default to English

  // Toggle between English and Farsi
  const toggleLanguage = () => {
    setLanguage(prevLanguage => prevLanguage === 'en' ? 'fa' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

// Custom hook to use the language context
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
} 